var exports = {
  "BZ": "avatarOuter__ZjFemh",
  "Y$": "avatarInner__OhgnP4",
  "cp": "avatarLink__sqWzwe",
  "z$": "hiddenActivityAvatar__VImFVi",
  "nR": "activityAvatar__jAnd8Q",
  "vk": "issueViewerAvatar__6GxGIQ",
  "Bo": "avatarWithDivider__EgMiKI",
  "DX": "avatarWithoutDivider__hNvr52",
  "GG": "avatarWithoutLink__Lv7q_I",
};

module.exports = exports;
